<template>
  <div class="benchmarks-message-container">
    <BenchmarksMessage
      :shouldBlurValues="shouldBlurValues"
      :category="category"
      :dataError="error"
      :brandError="brandError"
      :categoryError="categoryError"
      :isOptOutFromCategoryBenchmarksError="isOptOutFromCategoryBenchmarks"
      :noCategorySelected="noCategorySelected"
      @add="$emit('add')"
    />
  </div>
</template>

<script>
import BenchmarksMessage from './BenchmarksMessage.vue';

export default {
  props: {
    shouldBlurValues: {
      type: Boolean,
    },
    error: {
      type: Boolean,
    },
    categoryError: {
      type: Boolean,
    },
    brandError: {
      type: Boolean,
    },
    category: {
      type: String,
    },
    isOptOutFromCategoryBenchmarks: {
      type: Boolean,
    },
    noCategorySelected: {
      type: Boolean,
    },
  },
  components: {
    BenchmarksMessage,
  },
};
</script>

<style scoped>
.benchmarks-message-container {
  position: relative;
  width: 100%;
  height: 350px;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px rgb(0 0 0 / 40%);
  border-radius: 4px;
  margin: 8px 0px;
}
</style>
